import PropTypes from 'prop-types';
import clsx from 'clsx';
import Container from '@/components/Container';
import Link from '@/components/Link';

const defaultProps = {
  categories: [],
  active: null,
};

const propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object),
  active: PropTypes.string,
};

export default function Categories({ categories, active }) {
  return (
    <div className="relative z-20 bg-gray-900 text-gray-100">
      <Container>
        <nav className="flex w-full items-center space-x-4 py-2 lg:py-3">
          {categories.map(({ id, slug, name, uri }) => {
            const isActive = active === slug;
            return (
              <Link
                key={id}
                href={uri}
                className={clsx(
                  'flex items-center font-medium transition duration-150 ease-in-out md:text-lg',
                  isActive === true && 'pointer-events-none text-green-500',
                  isActive === false &&
                    'border-transparent text-gray-300 hover:text-white'
                )}
              >
                {name}
              </Link>
            );
          })}
        </nav>
      </Container>
    </div>
  );
}

Categories.defaultProps = defaultProps;
Categories.propTypes = propTypes;
